export default function HowItWorks() {
  const steps = [
    {
      num: "01",
      icon: "📋",
      title: "Paste Your Experience",
      desc: "Drop in raw notes, a job description, or a paragraph about what you did. No formatting needed.",
    },
    {
      num: "02",
      icon: "🤖",
      title: "AI Rewrites It",
      desc: "Our prompt sends your text to GPT-4, which applies resume writing best practices and quantification techniques.",
    },
    {
      num: "03",
      icon: "🚀",
      title: "Copy & Use",
      desc: "Get polished, ATS-optimized bullets ready to paste directly into your resume or LinkedIn.",
    },
  ];

  return (
    <section className="how-section" id="how-it-works">
      <h2 className="section-title">How It Works</h2>
      <div className="steps-grid">
        {steps.map((step) => (
          <div className="step-card" key={step.num}>
            <div className="step-icon">{step.icon}</div>
            <div className="step-num">{step.num}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-desc">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
